module.exports = __webpack_public_path__ + "static/UnclickYes-d9d3b9ab15d60a6b1684877d8d6f554f.png";